import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';

import type { Features } from '~/lib/api/features';
import { defaultFeaturesValue, getFeatures } from '~/lib/api/features';

export interface FeaturesModel {
    /**
     * List of available features
     */
    values: Features;

    /**
     * Retrieve available features from REST endpoint
     */
    loadFeatures: Thunk<FeaturesModel, never>;

    /**
     * Set the features in the store.
     */
    setFeatures: Action<FeaturesModel, Features>;
}

/**
 * Holds information about smartlearn instance features available.
 */
export const featuresModel: FeaturesModel = {
    values: defaultFeaturesValue,
    loadFeatures: thunk(async (actions) => {
        try {
            const features = await getFeatures();

            actions.setFeatures(features);
        } catch (error) {
            console.error(
                'Could not retrieve list of features from API',
                error,
            );
        }
    }),
    setFeatures: action((state, features) => {
        state.values = features;
    }),
};
